import Fade from '@mui/material/Fade';
export const CUSTOMER_PRIVATE_MENU = 'customerPrivateMenu';
export const DEFAULT_PROPS = {
    TransitionComponent: Fade,
    disableFocusListener: true,
    placement: 'bottom-start',
};
export const LAPTOP_PROPS = {
    enterDelay: 50,
};
export const TABLET_PROPS = {
    disableHoverListener: true,
    disableTouchListener: true,
};
//# sourceMappingURL=constants.js.map